import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DashboarddemoService } from '../Dashboad1.service';

@Component({
  selector: 'app-announcements1',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.css']
})
export class AnnouncementsdemoComponent implements OnInit {
  data: any;
  displayedColumns: string[] = ['Top Learners', 'Courses Completed'];

  constructor(private service:DashboarddemoService) { }

  ngOnInit() {
    this.GetTopLearner();
  }
  GetTopLearner(){
    this.service.GetTopLearners().subscribe(x => {
      this.data = x;
    });
}
navigatetoESD(){
  window.open(environment.esdMyLearningUrl+'/dashboard')
}

}
